<template>
  <span :class="['inline-flex items-center rounded-full font-normal whitespace-nowrap', colorClass, sizeClass]">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary", "red", "green", "gray", "yellow"].indexOf(value) !== -1,
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md"].indexOf(value) !== -1,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorClass() {
      const colorMap = {
        primary: this.dark ? "bg-primary-600 text-primary-100" : "bg-primary-100 text-primary-600",
        secondary: this.dark ? "bg-secondary-600 text-secondary-100" : "bg-secondary-100 text-secondary-600",
        green: this.dark ? "bg-green-600 text-green-100" : "bg-green-100 text-green-600",
        red: this.dark ? "bg-red-600 text-red-100" : "bg-red-100 text-red-600",
        yellow: this.dark ? "bg-yellow-600 text-yellow-100" : "bg-yellow-100 text-yellow-600",
        gray: this.dark ? "bg-gray-600 text-gray-100" : "bg-gray-100 text-gray-600",
      };
      return colorMap[this.color] || colorMap.primary;
    },
    sizeClass() {
      let returnClass = "";

      switch (this.size) {
        case "xs":
          returnClass = "px-1.5 py-0.4 text-xxs leading-4";
          break;
        case "sm":
          returnClass = "px-2.5 py-0.5 text-xs leading-4";
          break;
        case "md":
          returnClass = "px-3 py-0.5 text-sm leading-5";
          break;
        default:
          returnClass = "px-3 py-0.5 text-sm leading-5";
          break;
      }
      return returnClass;
    },
  },
};
</script>
<style scoped>
.text-xxs {
  font-size: 0.7rem;
}
</style>
